import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=2dd55813&scoped=true"
import script from "./whiteList.vue?vue&type=script&lang=js"
export * from "./whiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd55813",
  null
  
)

export default component.exports